import {useParams} from 'react-router-dom';
import { Tab, Tabs} from 'react-bootstrap';
import SiteDetails from '../components/siteDetailComponents/SiteDetails';
import SiteDevices from '../components/siteDetailComponents/SiteDevices';
import SitePhones from '../components/siteDetailComponents/SitePhones';
import SiteDattoRMM from '../components/siteDetailComponents/SiteDattoRMM';
import SiteProblems from '../components/siteDetailComponents/SiteProblems';
import SitePhotos from '../components/siteDetailComponents/SitePhotos';
import SiteDocs from '../components/siteDetailComponents/SiteDocs';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {useEffect} from 'react';
import { useGetSiteDetailsQuery } from '../slices/sitesApiSlice';

const SiteDetailScreen = () => {
    const navigate = useNavigate();
    const {userInfo} = useSelector((state) => state.auth);
    useEffect(() => {
        if(!userInfo){
            navigate('/login');
        }
    }, [userInfo, navigate])
    const {id: siteId} = useParams();
    const {data: data, isLoading, error} = useGetSiteDetailsQuery(siteId, {
        skip: !userInfo || !siteId
    });
   
    if (!userInfo) {
        return null;
    }

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&family=Outfit:wght@300;400;500;600;700;800&display=swap');

        body {
          background-color: var(--site-bg-color) !important;
        }

        .modern-details-container {
          color: #ffffff;
          font-family: 'Outfit', 'Inter', sans-serif;
          max-width: 1300px;
          margin: 0 auto;
          padding: 20px;
        }

        /* Back button styling */
        .back-btn {
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.1);
          color: #dfe6e9;
          padding: 8px 16px;
          border-radius: 8px;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          margin-bottom: 20px;
          display: inline-flex;
          align-items: center;
          gap: 6px;
        }

        .back-btn:hover {
          background: rgba(255, 255, 255, 0.12);
          border-color: rgba(255, 255, 255, 0.2);
          color: #ffffff;
          transform: translateX(-3px);
        }

        /* Site Header Block */
        .site-header-block {
          margin-bottom: 30px;
        }

        .site-tag {
          font-size: 11px;
          font-weight: 800;
          letter-spacing: 2px;
          color: #00cec9;
          text-transform: uppercase;
          margin-bottom: 4px;
        }

        .site-title {
          font-size: 32px;
          font-weight: 700;
          background: linear-gradient(135deg, #ffffff 40%, #00cec9 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          margin: 0;
        }

        .site-abbr {
          font-size: 20px;
          font-weight: 500;
          color: #b2bec3;
          -webkit-text-fill-color: initial;
        }

        /* Bootstrap Custom Tabs */
        .modern-details-container .nav-tabs {
          border-bottom: 1px solid rgba(255, 255, 255, 0.08) !important;
          margin-bottom: 24px !important;
          gap: 8px;
        }

        .modern-details-container .nav-link {
          background: rgba(30, 39, 46, 0.4) !important;
          border: 1px solid rgba(255, 255, 255, 0.05) !important;
          color: #b2bec3 !important;
          font-weight: 600;
          font-size: 14px;
          padding: 12px 20px;
          border-radius: 10px 10px 0 0 !important;
          transition: all 0.3s ease;
        }

        .modern-details-container .nav-link:hover {
          background: rgba(255, 255, 255, 0.05) !important;
          color: #ffffff !important;
          border-color: rgba(255, 255, 255, 0.1) !important;
        }

        .modern-details-container .nav-link.active {
          background: rgba(30, 39, 46, 0.8) !important;
          color: #00cec9 !important;
          border: 1px solid rgba(255, 255, 255, 0.1) !important;
          border-bottom: 2px solid #00cec9 !important;
          box-shadow: 0 -4px 15px rgba(0, 206, 201, 0.1);
        }

        .modern-details-container .nav-link.disabled {
          opacity: 0.4;
          cursor: not-allowed;
        }

        /* Tables override styling */
        .modern-details-container table {
          background: rgba(30, 39, 46, 0.4) !important;
          border: 1px solid rgba(255, 255, 255, 0.05) !important;
          border-collapse: separate !important;
          border-spacing: 0 !important;
          border-radius: 12px !important;
          overflow: hidden !important;
          margin-bottom: 20px !important;
          width: 100% !important;
        }

        .modern-details-container table th,
        .modern-details-container table td {
          background: transparent !important;
          border-color: rgba(255, 255, 255, 0.05) !important;
          color: #ffffff !important;
          padding: 12px 16px !important;
          font-size: 14px !important;
        }

        .modern-details-container table th {
          font-weight: 600;
          color: #b2bec3 !important;
          width: 30%;
          border-right: 1px solid rgba(255, 255, 255, 0.05) !important;
        }

        .modern-details-container table td {
          color: #ffffff !important;
        }

        .modern-details-container table a {
          color: #00cec9 !important;
          text-decoration: none !important;
          transition: opacity 0.2s ease;
        }

        .modern-details-container table a:hover {
          opacity: 0.8;
          text-decoration: underline !important;
        }

        /* General Link Styling to ensure high contrast/readability */
        .modern-details-container a {
          color: #00cec9 !important;
          text-decoration: none !important;
          transition: color 0.2s ease;
        }

        .modern-details-container a:hover {
          color: #81ecec !important;
          text-decoration: underline !important;
        }

        .modern-details-container .colHeader {
          font-size: 16px;
          font-weight: 700;
          color: #00cec9;
          margin-bottom: 12px !important;
          letter-spacing: 1px;
          text-transform: uppercase;
        }

        /* Icon Buttons */
        .modern-details-container .tableButton {
          background: rgba(255, 255, 255, 0.05) !important;
          border: 1px solid rgba(255, 255, 255, 0.08) !important;
          border-radius: 6px !important;
          padding: 4px 8px !important;
          transition: all 0.2s ease !important;
          color: #ffffff !important;
          margin-left: 6px !important;
          margin-right: 2px !important;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }

        .modern-details-container .tableButton:hover {
          background: rgba(255, 255, 255, 0.12) !important;
          border-color: rgba(255, 255, 255, 0.15) !important;
          transform: scale(1.05) !important;
        }

        .modern-details-container .tableButton svg {
          width: 13px !important;
          height: 13px !important;
        }

        .modern-details-container .tableButton svg path {
          fill: currentColor !important;
        }

        /* Action Buttons */
        .modern-details-container .btn-primary,
        .modern-details-container .btn-sm {
          background: var(--btn-primary-bg) !important;
          border: 1px solid var(--btn-primary-border) !important;
          border-radius: 8px !important;
          color: #ffffff !important;
          font-weight: 600 !important;
          padding: 8px 16px !important;
          box-shadow: 0 2px 6px var(--btn-primary-shadow) !important;
          transition: all 0.2s ease !important;
        }

        .modern-details-container .btn-primary:hover,
        .modern-details-container .btn-sm:hover {
          background: var(--btn-primary-hover-bg) !important;
          border-color: var(--btn-primary-hover-border) !important;
          box-shadow: 0 4px 12px var(--btn-primary-hover-shadow) !important;
          transform: translateY(-1px) !important;
          opacity: 1;
        }

        /* Notes and Tasks Cards */
        .modern-details-container .noteCard {
          background: rgba(30, 39, 46, 0.4) !important;
          border: 1px solid rgba(255, 255, 255, 0.05) !important;
          border-radius: 12px !important;
          padding: 16px !important;
          margin-bottom: 16px !important;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2) !important;
          transition: all 0.3s ease;
        }

        .modern-details-container .noteCard:hover {
          border-color: rgba(13, 148, 136, 0.2) !important;
          background: rgba(30, 39, 46, 0.5) !important;
        }

        .modern-details-container .noteCard p {
          margin: 0 !important;
          color: #dfe6e9 !important;
        }

        .modern-details-container .noteCard .boldText {
          color: #a0aec0 !important;
        }

        .modern-details-container h3 {
          font-size: 20px;
          font-weight: 700;
          color: #ffffff;
          margin: 15px 0 !important;
          letter-spacing: 0.5px;
        }

        /* Map styling */
        .modern-details-container .leaflet-container {
          border-radius: 12px !important;
          border: 1px solid rgba(255, 255, 255, 0.08) !important;
          box-shadow: 0 8px 32px rgba(0,0,0,0.3) !important;
          filter: invert(90%) hue-rotate(200deg) brightness(85%) contrast(105%);
        }

        /* AG-Grid Alpine variables override */
        .modern-details-container .ag-theme-alpine {
          --ag-background-color: rgba(30, 39, 46, 0.6) !important;
          --ag-header-background-color: rgba(45, 52, 54, 0.8) !important;
          --ag-odd-row-background-color: rgba(255, 255, 255, 0.02) !important;
          --ag-row-hover-color: rgba(13, 148, 136, 0.05) !important;
          --ag-foreground-color: #ffffff !important;
          --ag-header-foreground-color: #00cec9 !important;
          --ag-border-color: rgba(255, 255, 255, 0.08) !important;
          --ag-secondary-foreground-color: #b2bec3 !important;
          --ag-input-focus-border-color: #00cec9 !important;
          
          border-radius: 12px;
          overflow: hidden;
          border: 1px solid rgba(255, 255, 255, 0.08);
        }

        .modern-details-container .ag-header-cell-text {
          color: #00cec9 !important;
          font-weight: 700 !important;
          letter-spacing: 0.5px !important;
        }

        .modern-details-container .ag-cell {
          color: #ffffff !important;
        }

        .modern-details-container .ag-root-wrapper {
          background-color: transparent !important;
          border: none !important;
        }

        .modern-details-container .ag-cell {
          display: flex;
          align-items: center;
        }

        /* Filter Controls */
        .modern-details-container input[type="text"].form-control {
          background-color: rgba(255, 255, 255, 0.05) !important;
          border: 1px solid rgba(255, 255, 255, 0.1) !important;
          color: #ffffff !important;
          border-radius: 8px !important;
          padding: 10px 14px !important;
        }

        .modern-details-container input[type="text"].form-control:focus {
          background-color: rgba(255, 255, 255, 0.08) !important;
          border-color: #00cec9 !important;
          box-shadow: 0 0 0 0.25rem rgba(13, 148, 136, 0.15) !important;
        }

        /* File Upload styling */
        .modern-details-container input[type="file"].form-control {
          background-color: rgba(255, 255, 255, 0.03) !important;
          border: 1px dashed rgba(255, 255, 255, 0.15) !important;
          padding: 20px !important;
          text-align: center !important;
          color: #b2bec3 !important;
          cursor: pointer !important;
        }

        .modern-details-container input[type="file"].form-control:hover {
          border-color: #00cec9 !important;
          background-color: rgba(255, 255, 255, 0.05) !important;
        }

        /* Global Overlay Modals */
        .modal-backdrop.show {
          opacity: 0.4 !important;
          backdrop-filter: blur(4px) !important;
          -webkit-backdrop-filter: blur(4px) !important;
        }

        .modal-content {
          background: rgba(30, 39, 46, 0.95) !important;
          backdrop-filter: blur(20px) !important;
          -webkit-backdrop-filter: blur(20px) !important;
          border: 1px solid rgba(255, 255, 255, 0.15) !important;
          border-radius: 16px !important;
          color: #ffffff !important;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3) !important;
        }

        .modal-header {
          border-bottom: 1px solid rgba(255, 255, 255, 0.08) !important;
          background: transparent !important;
          padding: 20px 24px !important;
        }

        .modal-header .btn-close {
          filter: invert(1) !important;
          opacity: 0.5 !important;
        }

        .modal-header .btn-close:hover {
          opacity: 0.8 !important;
        }

        .modal-title {
          font-weight: 700 !important;
          color: #ffffff !important;
          letter-spacing: 0.5px;
        }

        .modal-body {
          padding: 24px !important;
        }

        .modal-footer {
          border-top: 1px solid rgba(255, 255, 255, 0.08) !important;
          padding: 16px 24px !important;
          background: transparent !important;
        }

        .modal-footer .btn-secondary {
          background: rgba(255, 255, 255, 0.05) !important;
          border: 1px solid rgba(255, 255, 255, 0.08) !important;
          color: #dfe6e9 !important;
          border-radius: 8px !important;
          font-weight: 600 !important;
          padding: 8px 16px !important;
          transition: all 0.2s ease !important;
        }

        .modal-footer .btn-secondary:hover {
          background: rgba(255, 255, 255, 0.12) !important;
          color: #ffffff !important;
        }

        .modal-footer .btn-success,
        .modal-footer .btn-danger {
          border: none !important;
          border-radius: 8px !important;
          font-weight: 600 !important;
          padding: 8px 16px !important;
          transition: all 0.2s ease !important;
        }

        .modal-footer .btn-success {
          background: #27ae60 !important;
          box-shadow: 0 2px 6px rgba(39, 174, 96, 0.15) !important;
        }

        .modal-footer .btn-success:hover {
          background: #219653 !important;
          box-shadow: 0 4px 12px rgba(39, 174, 96, 0.3) !important;
          transform: translateY(-1px) !important;
        }

        .modal-footer .btn-danger {
          background: #d63031 !important;
          box-shadow: 0 2px 6px rgba(214, 48, 49, 0.15) !important;
        }

        .modal-footer .btn-danger:hover {
          background: #b71c1c !important;
          box-shadow: 0 4px 12px rgba(214, 48, 49, 0.3) !important;
          transform: translateY(-1px) !important;
        }

        .modal-body .form-label {
          color: #b2bec3 !important;
          font-weight: 600 !important;
          font-size: 13px !important;
          margin-bottom: 6px !important;
        }

        .modal-body .form-control,
        .modal-body .form-select {
          background-color: rgba(255, 255, 255, 0.05) !important;
          border: 1px solid rgba(255, 255, 255, 0.1) !important;
          color: #ffffff !important;
          border-radius: 8px !important;
          padding: 10px 14px !important;
          font-size: 14px !important;
        }

        .modal-body .form-control:focus,
        .modal-body .form-select:focus {
          background-color: rgba(255, 255, 255, 0.08) !important;
          border-color: #00cec9 !important;
          box-shadow: 0 0 0 0.25rem rgba(13, 148, 136, 0.15) !important;
          color: #ffffff !important;
        }

        /* Connect Button on DattoRMM grid */
        .modern-details-container .btn-connect-green {
          background-color: #27ae60 !important;
          border: 1px solid #219653 !important;
          color: #ffffff !important;
          font-weight: 600 !important;
          transition: all 0.2s ease !important;
          box-shadow: 0 2px 4px rgba(39, 174, 96, 0.2) !important;
        }

        .modern-details-container .btn-connect-green:hover {
          background-color: #219653 !important;
          border-color: #1e8449 !important;
          box-shadow: 0 4px 8px rgba(39, 174, 96, 0.35) !important;
          transform: translateY(-1px) !important;
          color: #ffffff !important;
        }
      `}</style>

      {isLoading ? (
        <div className="text-center py-5">
          <h2 className="text-dark">Loading Site Details...</h2>
        </div>
      ) : error ? (
        <div className="alert alert-danger">
          {error?.data?.message || error.error || "An error occurred."}
        </div>
      ) : (
        <div className="modern-details-container">
          {/* Back to Dashboard Navigation
          <button onClick={() => navigate('/')} className="back-btn">
            ← Back to Dashboard
          </button> */}

          {/* Site Title and Company Accent Info */}
          <div className="site-header-block">
            <div className="site-tag">{data?.site?.company || "DOC Operations Center"}</div>
            <h1 className="site-title">
              {data?.site?.name} {data?.site?.abbr && <span className="site-abbr">({data.site.abbr})</span>}
            </h1>
          </div>

          <Tabs
            defaultActiveKey="info"
            id="fill-tab-example"
            className="mb-3"
            fill
            mountOnEnter={true}
          >
            <Tab eventKey="info" title="Site Info">
              <SiteDetails siteInfo={data.site} isps={data.isps} siteNotes={data.notes} siteTasks={data.tasks} />
            </Tab>
            <Tab eventKey="devices" title="Devices">
              <SiteDevices siteDevices={data.devices} site={data.site} />
            </Tab>
            <Tab eventKey="dattormm" title="DattoRMM">
              <SiteDattoRMM site={data.site} />
            </Tab>
            <Tab eventKey="phones" title="Phones">
              <SitePhones sitePhones={data.phones} site={data.site} />
            </Tab>
            <Tab eventKey="photos" title="Photos">
              {data.site && (<SitePhotos filesite={data.site} />)}
            </Tab>
            <Tab eventKey="docs" title="Docs">
              {data.site && (<SiteDocs filesite={data.site} />)}
            </Tab>
            <Tab disabled eventKey="problems" title="Problems">
              <SiteProblems />
            </Tab>
          </Tabs>
        </div>
      )}
    </>
  );
};

export default SiteDetailScreen;